<template>
  <div class="info-modal">
    <!-- お知らせリンククリック後に表示される画面の内容 -->
    <div class="modal" @click.self="$emit('close')" style="display: block">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4  class="modal-title">{{Infolist.infoSubject}}</h4>
          </div>
          <div class="modal-body">
            <label>{{Infolist.infoDetail}}</label>
          </div>
          <div class="modal-footer">
            <div class="col-sm-2">
              <button type="button" class="btn btn-secondary" @click="$emit('close')">閉じる</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop show"></div>
  </div>
</template>

<script>

export default {
  props: {
    Infolist: {
      no: Number,
      viewDay: String,
      infoContent: String,
      detail: String,
    },
  },
  
}
</script>

<style scoped>
label{
  white-space: pre-wrap;
}
</style>